import type { KennelArea } from '../bookings/types';

export interface AreaPillProps {
  area: KennelArea;
  label: string;
}

export function AreaPill({ area, label }: AreaPillProps) {
  // Area reads as plain cell data now — no badge. The `area-<key>` hook stays
  // for anything keying off it, but visually it's just text like any other column.
  return <span className={'area-text area-' + area}>{label}</span>;
}
